import type { StringMatchPart } from './StringMatchPart';

type Args = {
  text: string;
  regex: RegExp;
};

export function breakStringByRegex({ text, regex }: Args): StringMatchPart[] {
  const globalRegExp = new RegExp(regex, `g${regex.flags}`);

  const matches = Array.from(text.matchAll(globalRegExp));
  const parts: StringMatchPart[] = [];

  let lastIndex = 0;
  matches.forEach((match) => {
    const [matchText] = match;
    const { index } = match;

    if (index === undefined) return;

    if (index > lastIndex) {
      parts.push({
        type: 'remaining',
        partText: text.slice(lastIndex, index),
      });
    }

    parts.push({ type: 'match', partText: matchText });
    lastIndex = index + matchText.length;
  });

  if (lastIndex !== text.length - 1) {
    parts.push({ type: 'remaining', partText: text.slice(lastIndex) });
  }

  return parts;
}
